export enum Alerts {
  INFO = 'info',
  SUCCESS = 'success',
  ERROR = 'error',
  UNITE_ERROR = 'unite-error',
  WARNING = 'warning',
  PRO = 'pro',
  NEUTRAL = 'neutral',
}
